/* eslint-disable react/no-unused-state,react/no-unescaped-entities */
import React, { memo, useState, useEffect } from "react";
import { Card, CardBody, Col, Modal, ModalBody, Alert, Spinner } from "reactstrap";
import { AiOutlineFolderView } from "react-icons/ai";
import { MdRefresh } from "react-icons/md";

// import { Link } from "react-router-dom";
// import { MdModeEdit, MdInsertDriveFile, MdLock } from "react-icons/md";
import DataTable from "../../../../shared/components/DataTable";
import { withRouter, Link } from "react-router-dom";
import {
    MdArrowBack,
    MdClear,
    // MdFileUpload, MdInvertColors
} from "react-icons/md";
import { connect } from "react-redux";
import "react-confirm-alert/src/react-confirm-alert.css";
// import "../customisedCss/alert.css";
// import AccessControl from "../../../../shared/components/AccessControl";
import { permissionsConstants } from "../../../../constants/permission.constants";
// import { accessControlFn } from "../../../../utils/accessControl";
// import Avatar from "react-avatar";
import { getFormValues } from "redux-form";
import { getRoles, getRolesPermission, resetPermissions } from "../../actions/roles.actions";

const {
    // CREATE_USER,
    // ENABLE_USER,
    // DISABLE_USER,
    VIEW_USER,
    // UPDATE_USER,
    // CHANGE_USER_ROLE,
} = permissionsConstants;

const RoleTable = memo((props) => {
    const { dataState, currentUser, dispatch, permissions, allUsers, rolesPermissions } = props;
    const foundPermission = rolesPermissions && rolesPermissions.response && rolesPermissions.response.data && rolesPermissions.response.data.length && !rolesPermissions.loading ? true : false;
    const [searchKey, setSearchKey] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [roleId, setRoleId] = useState(null);
    const [roleName, setRoleName] = useState(null);
    useEffect(() => {
        dispatch(getRoles(currentUser?.response?.domainCode));
    }, [dispatch]);

    const openModal = (role) => {
        setIsModalOpen(true);
        setRoleId(role.id);
        setRoleName(role.name);
        //make api calls to permission
        dispatch(getRolesPermission(role.id));
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setRoleId(null);
        setRoleName(null);
        //make api calls to reset permission
        dispatch(resetPermissions());
    };

    const fetchPermission = () => {
        //fetch api call
        dispatch(getRolesPermission(roleId));
    };
    const count = dataState.response?.data?.length || 0;

    const columns = [
        {
            accessor: "name",
            name: "Role Name",
            filterable: false,
            sortable: true,
            sortKey: "name",
            renderHeader: () => <div>Role Name</div>,
        },

        // {
        //   accessor: "domain",
        //   name: "Domain Name",
        //   filterable: false,
        //   sortable: true,
        //   sortKey: "domain",
        // },
        // {
        //   accessor: "permissions",
        //   name: "Permissions",
        //   sortable: true,
        //   sortKey: "permissions",
        // }
    ];
    const handleAction = (row) => {
        try {
            if (row && row.id) {
                openModal(row);
            }
        } catch (err) {
            console.error(err);
        }
    };
    const actions = [
        {
            name: "view_permissions",
            btnText: "View",
            btnAction: handleAction,
            btnClass: "success",
            btnIcon: AiOutlineFolderView,
            permissions: [],
            showButton: false,
        },
    ];

    const loadData = () => {
        dispatch(getRoles(currentUser?.response?.domainCode));
    };

    return (
        <Col md={12} lg={12}>
        
            <Modal isOpen={isModalOpen} centered={true} onClosed={closeModal} toggle={closeModal}>
                <ModalBody>
                    <Col>
                        <Card>
                            <CardBody style={{ textAlign: "center", padding: "unset" }}>
                                {rolesPermissions && rolesPermissions.error ? (
                                    <Col md={12} style={{ padding: "0" }}>
                                        <Alert color="danger">
                                            Could not fetch Permissions
                                            {rolesPermissions && rolesPermissions.loading ? <Spinner className="float-right" size="sm" color="danger" /> : <MdRefresh onClick={fetchPermission} className="float-right pointer" size={20} />}
                                        </Alert>
                                    </Col>
                                ) : foundPermission ? (
                                    <Col>
                                        <div style={{ display: "flex", flexDirection: "row-reverse", width: "429px" }}>
                                            <MdClear onClick={() => closeModal()} size={17} style={{ color: "red", cursor: "pointer" }} />
                                        </div>

                                        <h3>Permissions</h3>
                                        <hr />
                                        <div className="smallPermissions-framework">
                                            {rolesPermissions && rolesPermissions.response && rolesPermissions.response.data
                                                ? rolesPermissions.response.data.map((value, index) => (
                                                      <div className="smallPermissions-container">
                                                          <div className="rolesCard" key={index}>
                                                              <small>{value.name}</small>
                                                          </div>
                                                      </div>
                                                  ))
                                                : null}
                                        </div>
                                    </Col>
                                ) : null}
                                <Col>
                                    <div>
                                        {rolesPermissions && rolesPermissions.loading ? <Spinner color="success" className="my-4" style={{ width: "6rem", height: "6rem" }} /> : null}
                                        {rolesPermissions && rolesPermissions.loading ? <h4 className="text-secondary">Fetching Permissions Assigned to this role: ({roleName})</h4> : null}
                                    </div>
                                </Col>
                            </CardBody>
                        </Card>
                    </Col>
                </ModalBody>
            </Modal>
            <Card>
                <CardBody>
                    <div className="card__title">
                        <h5 className="bold-text">
                            <Link to="/users" id="link-all-users">
                                <MdArrowBack size={20} /> Back to Users List
                            </Link>
                        </h5>
                    </div>
                    <div>
                        <DataTable
                            columns={columns}
                            loading={dataState && dataState.loading}
                            data={dataState && dataState.response ? dataState.response.data : []}
                            count={count}
                            countName="Roles"
                            defaultPageSize={10}
                            defaultPageNumber={1}
                            loadData={loadData}
                            error={dataState && dataState.error}
                            bordered={true}
                            striped={true}
                            hover={true}
                            permissions={permissions}
                            actions={actions}
                            clearSearch={() => {}}
                            responsive
                            searchKey={searchKey}
                            serverside
                            hidePagination={true}
                        />
                    </div>
                </CardBody>
            </Card>
        </Col>
    );
});

export default connect((state) => ({
    searchValues: getFormValues("custom_search")(state),
    permissions: state.permissions && state.permissions.response,
    dataState: state.roles,
    currentUser: state.currentUser,
    rolesPermissions: state.getRolesPermissions,
}))(withRouter(RoleTable));
